module.exports = __webpack_public_path__ + "static/img/car-lines.c1989785.png";